"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linkedin = void 0;
var _react = _interopRequireDefault(require("react"));
var Linkedin = exports.Linkedin = function Linkedin() {
  return _react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "30",
    height: "30",
    fill: "white"
  }), _react["default"].createElement("path", {
    d: "M30.6737 30.6744H25.3396V22.3208C25.3396 20.3287 25.3041 17.7644 22.5654 17.7644C19.7872 17.7644 19.3621 19.9348 19.3621 22.1757V30.6739H14.028V13.4953H19.1488V15.843H19.2204C19.7329 14.9667 20.4734 14.2459 21.3632 13.7572C22.2529 13.2686 23.2585 13.0304 24.2728 13.068C29.6791 13.068 30.6759 16.6242 30.6759 21.2506L30.6737 30.6744ZM8.00944 11.1472C7.39722 11.1473 6.7987 10.9658 6.2896 10.6258C5.7805 10.2857 5.38369 9.80234 5.14931 9.23675C4.91492 8.67115 4.85349 8.04876 4.97282 7.44826C5.09215 6.84776 5.38687 6.29614 5.8197 5.86314C6.25253 5.43015 6.80403 5.13523 7.40446 5.01568C8.0049 4.89613 8.62728 4.95732 9.19294 5.19151C9.7586 5.4257 10.2421 5.82237 10.5823 6.33137C10.9226 6.84037 11.1042 7.43883 11.1043 8.05107C11.1044 8.45758 11.0244 8.86012 10.8689 9.23572C10.7134 9.61131 10.4855 9.95261 10.1981 10.2401C9.91071 10.5276 9.56948 10.7557 9.19396 10.9113C8.81843 11.0669 8.41594 11.1471 8.00944 11.1472ZM10.6765 30.6744H5.33685V13.4953H10.6765V30.6744ZM33.333 0.00245274H2.65649C1.96022 -0.00540493 1.28928 0.263495 0.79116 0.750064C0.293043 1.23663 0.00849759 1.90106 0 2.59735V33.4021C0.00820675 34.0988 0.292585 34.7636 0.790685 35.2507C1.28879 35.7378 1.95987 36.0072 2.65649 35.9998H33.333C34.031 36.0085 34.7039 35.7399 35.204 35.2528C35.7041 34.7658 35.9903 34.1001 36 33.4021V2.59512C35.99 1.89746 35.7036 1.23227 35.2035 0.745716C34.7034 0.25916 34.0306 -0.00897215 33.333 0.000229233",
    fill: "#0A66C2"
  }));
};